import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "../api";
import { FaEye, FaTrash, FaPlus,FaSearch, FaTimes, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight, FaUserCheck, FaHourglassHalf, FaUserTimes, FaDownload, FaEdit, FaExclamationTriangle, FaCheckCircle, FaInfoCircle, FaFilePdf, FaFileDownload, FaFileAlt } from 'react-icons/fa';
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import {
  Row,
  Col,
  Button,
  Alert,
  Table,
  Card,
  Spinner,
  CardHeader,
  CardBody,
  Badge,
  Container,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  ListGroup,
  ListGroupItem
} from "reactstrap";
import "./Datarecap.css"
import { useNavigate } from "react-router-dom";
import Filters from "./RegisterUsulanFolder/Filter";
import { DEFAULT_FILTERS } from "./RegisterUsulanFolder/OptionsFilter";
import CreateModal from "./RegisterUsulanFolder/CreateModal";
import EditModal from "./RegisterUsulanFolder/EditModal";
import ViewModal from "./RegisterUsulanFolder/ViewModal";
import DeleteModal from "./RegisterUsulanFolder/DeleteModal";
import { openInAppFilePreview } from '../utils/filePreviewBus';
import { toProtectedFileUrl } from '../utils/secureFile';
import { kecamatanOptions } from "./RegisterUsulanFolder/OptionsFilter";
import { useDebouncedTextFilters } from "../hooks/useDebouncedTextFilters";

const RegisterUsulan = () => {
  const navigate = useNavigate();
  const [verifikasiLoading, setVerifikasiLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [desaOptions, setDesaOptions] = useState([]);
  const [isVerifikasiModalOpen, setIsVerifikasiModalOpen] = useState(false);
  const [verifikasiData, setVerifikasiData] = useState({ item: null, status: "" });
  const [selectedItem, setSelectedItem] = useState(null);
  const { user } = useSelector((state) => state.authAdmin || {});
  const isReadOnly = user?.role === "Bupati";

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const [selectedKecamatan, setSelectedKecamatan] = useState("");
  const [filters, setFilters] = useState({ ...DEFAULT_FILTERS, user: "" });
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [filterDesaOptions, setFilterDesaOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);

  // Scroll sync refs
  const topScrollRef = React.useRef(null);
  const tableScrollRef = React.useRef(null);
  const fetchIdRef = useRef(0);
  const abortControllerRef = useRef(null);
  const queryFilters = useDebouncedTextFilters(
    filters,
    ["searchName", "searchNameKK", "searchNoKK", "searchNik", "searchAlamat"]
  );

  // Import Excel state
  const [importFile, setImportFile] = useState(null);
  const [importResult, setImportResult] = useState(null);
  const [importLoading, setImportLoading] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const getDesaOptions = useCallback((kecamatan) => {
    if (kecamatan && kecamatanOptions[kecamatan]) {
      return kecamatanOptions[kecamatan];
    }
    return [];
  }, []);

  useEffect(() => {
    if (selectedItem?.kecamatan) {
      setDesaOptions(getDesaOptions(selectedItem.kecamatan));
    } else {
      setDesaOptions([]);
    }
  }, [selectedItem, getDesaOptions]);

  // Update daftar desa/kelurahan berdasarkan filter kecamatan
  useEffect(() => {
    if (filters.kecamatan && filters.kecamatan !== "Semua Kecamatan") {
      setFilterDesaOptions(getDesaOptions(filters.kecamatan));
    } else {
      setFilterDesaOptions([]);
    }
  }, [filters.kecamatan, getDesaOptions]);

  // Fetch user options untuk filter
  useEffect(() => {
    const fetchUserOptions = async () => {
      try {
        const res = await axios.get("/userfilter");
        setUserOptions(res.data || []);
      } catch (err) {
        console.error("Gagal memuat daftar user:", err);
      }
    };
    fetchUserOptions();
  }, []);

  const fetchData = useCallback(async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const fetchId = ++fetchIdRef.current;

    setLoading(true);
    setError("");
    try {
      const params = {
        page: currentPage,
        limit,
        status: queryFilters.status === "Semua Status" ? "" : queryFilters.status,
        searchAlamat: queryFilters.searchAlamat?.trim(),
        searchNameKK: queryFilters.searchNameKK?.trim(),
        searchNoKK: queryFilters.searchNoKK?.trim(),
        searchNik: queryFilters.searchNik?.trim(),
        searchName: queryFilters.searchName?.trim(),
        tanggalDiterima: queryFilters.tanggalDiterima,
        tanggalSurat: queryFilters.tanggalSurat,
        tanggalMulaiDiterima: queryFilters.tanggalMulaiDiterima,
        tanggalSelesaiDiterima: queryFilters.tanggalSelesaiDiterima,
        tanggalMulaiSurat: queryFilters.tanggalMulaiSurat,
        tanggalSelesaiSurat: queryFilters.tanggalSelesaiSurat,
        tanggalMulai: queryFilters.tanggalMulai,
        tanggalSelesai: queryFilters.tanggalSelesai,
        tahun: queryFilters.tahun === "Semua Tahun" ? "" : queryFilters.tahun,
        kecamatan: queryFilters.kecamatan === "Semua Kecamatan" ? "" : queryFilters.kecamatan,
        desaKelurahan: queryFilters.kelurahan === "Semua Kelurahan" ? "" : queryFilters.kelurahan,
        perihal: queryFilters.perihal === "Semua Perihal" ? "" : queryFilters.perihal,
        user: queryFilters.user === "Semua User" ? "" : queryFilters.user,
      };

      Object.keys(params).forEach(key => {
        if (params[key] === "" || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });

      const res = await axios.get("/getregisterusulan", { params, signal: controller.signal });
      if (fetchId !== fetchIdRef.current) return;

      setData(res.data.registerUsulan || []);
      setTotalItems(res.data.totalItems || 0);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
      if (fetchId !== fetchIdRef.current) return;
      setData([]);
      setTotalItems(0);
      setTotalPages(1);
      setError(err?.response?.data?.message || "Gagal memuat data");
    } finally {
      if (fetchId === fetchIdRef.current) {
        setLoading(false);
      }
    }
  }, [currentPage, limit, queryFilters]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "kecamatan" ? { kelurahan: "" } : {})
    }));
    setCurrentPage(1);
  };

  const handleCreate = async (form) => {
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== "") {
        fd.append(k, v);
      }
    });
    await axios.post("/createregisterusulan", fd, { headers: { "Content-Type": "multipart/form-data" } });
    setSuccess("Berhasil menambah data");
    fetchData();
  };

  const handleUpdate = async (form) => {
    if (!selectedItem) return;
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== "") {
        fd.append(k, v);
      }
    });
    await axios.put(`/updateregisterusulan/${selectedItem.id}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
    setSuccess("Berhasil memperbarui data");
    fetchData();
  };

  const handleDelete = async () => {
    if (!selectedItem) return;
    await axios.delete(`/deleteregisterusulan/${selectedItem.id}`);
    setSuccess("Berhasil menghapus data");
    fetchData();
  };

  // Baca pesan error dari response blob (server mengirim JSON saat gagal)
  const readBlobError = async (error) => {
    try {
      const data = error?.response?.data;
      if (data instanceof Blob) {
        const text = await data.text();
        const json = JSON.parse(text);
        return json.message || json.msg || 'File tidak ditemukan di server';
      }
      return error?.response?.data?.message || error?.message || 'Gagal mengunduh file';
    } catch {
      return 'File tidak ditemukan di server';
    }
  };

  const handleDownload = async (item) => {
    if (!item.file) {
      setError('Tidak ada lampiran file untuk data ini');
      return;
    }
    try {
      const res = await axios.get(`/downloadpdfregisterusulan/${item.id}/download`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = item.file || `register-usulan-${item.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setSuccess('Lampiran berhasil diunduh');
    } catch (e) {
      setError(await readBlobError(e));
    }
  };

  const handleAdminExport = async () => {
    try {
      const params = new URLSearchParams({
        kecamatan: selectedKecamatan || ""
      }).toString();

      const res = await axios.get(`/exportregisterusulan/export/excel?${params}`, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;

      const fileName = selectedKecamatan
        ? `register_usulan_${selectedKecamatan}_${Date.now()}.xlsx`
        : `register_usulan_all_${Date.now()}.xlsx`;

      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSuccess(`Data berhasil diexport${selectedKecamatan ? ` untuk kecamatan ${selectedKecamatan}` : ' semua kecamatan'}`);
    } catch (err) {
      setError("Gagal mengeksport data Excel");
      console.error('Admin export error:', err);
    }
  };

  // IMPROVED IMPORT HANDLERS
  const onPickImportFile = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    
    if (file) {
      // Validasi tipe file
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ];
      const isValidType = validTypes.includes(file.type) || file.name.match(/\.(xlsx|xls)$/);
      
      if (!isValidType) {
        setError('Tipe file tidak valid. Hanya file Excel (.xlsx atau .xls) yang diperbolehkan.');
        return;
      }

      // Validasi ukuran file (max 5MB)
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        setError(`Ukuran file terlalu besar (${(file.size / (1024 * 1024)).toFixed(2)}MB). Maksimal 5MB.`);
        return;
      }

      setImportFile(file);
      setImportResult(null);
      setError('');
    }
  };

const handleImportExcel = async (file) => {
    const fd = new FormData();
    fd.append('file', file);

    try {
        const response = await axios.post('/uploadregisterusulan/import/excel', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });

        // console.log('✅ SUCCESS RESPONSE:', response.data);
        return response.data;
    } catch (error) {
        // console.log('🔴 ERROR DETAILS:', error);
        if (error.response && (error.response.status === 400 || error.response.status === 207)) {
            console.log('🟡 PARTIAL SUCCESS/ERROR WITH DATA:', error.response.data);
         
            return error.response.data;
        }
        
        if (error.response) {
            throw new Error(error.response.data.message || 'Import gagal');
        } else if (error.request) {
            throw new Error('Tidak dapat terhubung ke server. Periksa koneksi internet Anda.');
        } else {
            throw new Error('Terjadi kesalahan: ' + error.message);
        }
    }
};

const onSubmitImport = async () => {
    if (!importFile) {
        setError('Silakan pilih file Excel terlebih dahulu.');
        return;
    }

    setImportLoading(true);
    setError('');
    setImportResult(null);

    try {
        const result = await handleImportExcel(importFile);
        
        console.log('FINAL PROCESSED RESULT:', result);

        const isSuccess = result.status === 'success';
        const isPartial = result.status === 'partial';
        const isErrorWithData = result.status === 'error' && result.data;
        
        setImportResult({
            success: isSuccess || isPartial,
            status: result.status,
            message: result.message,
            data: result.data, // Data selalu ada untuk error 400/207
            hint: result.hint
        });

        // Reset file input
        setImportFile(null);
        const fileInput = document.getElementById("fileMasuk");
        if (fileInput) fileInput.value = '';

        // Refresh data jika ada yang berhasil
        if (result.data && result.data.success > 0) {
            await fetchData();
        }

        // Show modal dengan hasil
        setShowImportModal(true);

    } catch (err) {
        console.log('❌ UNHANDLED ERROR:', err);
        
        // Error yang tidak memiliki data useful
        setImportResult({
            success: false,
            status: 'error',
            message: err.message,
            hint: 'Terjadi kesalahan sistem. Silakan coba lagi.',
            data: null
        });
        setShowImportModal(true);
    } finally {
        setImportLoading(false);
    }
};
  const handleDownloadFullPDF = async (item) => {
    try {
      setLoading(true);

      const res = await axios.get(
        `/exportregisterusulan/${item.id}/pdf`,
        {
          responseType: 'blob',
          timeout: 30000
        }
      );

      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const namaKepalaKeluarga = item.namaKepalaKeluarga || 'unknown';
      const nomorSurat = item.nomorSurat || 'unknown';
      const namaPemohonLembagaPengusul = item.namaPemohonLembagaPengusul || 'unknown';

      const cleanFileName = (text) => {
        if (!text) return 'unknown';
        return text
          .toString()
          .replace(/[<>:"/\\|?*]/g, '')
          .replace(/\s+/g, '_')
          .trim();
      };

      const fileName = `${cleanFileName(namaKepalaKeluarga)}.${cleanFileName(nomorSurat)}.${cleanFileName(namaPemohonLembagaPengusul)}.pdf`;

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      setSuccess('PDF berhasil didownload');
    } catch (error) {
      setError('Gagal mendownload PDF: ' + (await readBlobError(error)));
    } finally {
      setLoading(false);
    }
  };

  const handleVerifikasi = async (item, status) => {
    setVerifikasiData({ item, status });
    setIsVerifikasiModalOpen(true);
  };

  const confirmVerifikasi = async () => {
    if (!verifikasiData.item) return;

    setVerifikasiLoading(true);
    setError("");

    try {
      await axios.put(`/verifikasiusulan/${verifikasiData.item.id}`, { status: verifikasiData.status });

      setData(prevData =>
        [...prevData].map(item =>
          item.id === verifikasiData.item.id
            ? { ...item, status: verifikasiData.status }
            : item
        )
      );

      setSuccess(`Status berhasil diubah menjadi ${verifikasiData.status}`);

      setIsVerifikasiModalOpen(false);
      setVerifikasiData({ item: null, status: "" });
      setVerifikasiLoading(false);

    } catch (err) {
      setError(err?.response?.data?.message || 'Gagal mengubah status');
      console.error('Error verifikasi:', err);
      setVerifikasiLoading(false);
    }
  };

const ImportResultModal = () => {
    if (!importResult) return null;

    const { success, status, message, data, hint } = importResult;

    const getIconAndColor = () => {
        if (status === 'success') return { icon: FaCheckCircle, color: 'success' };
        if (status === 'partial') return { icon: FaExclamationTriangle, color: 'warning' };
        return { icon: FaTimes, color: 'danger' };
    };

    const { icon: Icon, color } = getIconAndColor();
    
    // Data selalu ada untuk status 'error' dengan kode 400/207
    const hasData = data && typeof data === 'object';
    const totalProcessed = hasData ? (data.success + data.failed) : 0;
    const successRate = totalProcessed > 0 ? Math.round((data.success / totalProcessed) * 100) : 0;
    
    // Cek duplikat - data.duplicates mungkin array kosong atau undefined
    const duplicates = hasData ? (data.duplicates || []) : [];
    const hasDuplicates = duplicates.length > 0;
    
    const errors = hasData ? (data.errors || []) : [];
    const hasErrors = errors.length > 0;

    return (
        <Modal isOpen={showImportModal} toggle={() => setShowImportModal(false)} size="lg">
            <ModalHeader toggle={() => setShowImportModal(false)}>
                <Icon className={`me-2 text-${color}`} />
                Hasil Import Excel
            </ModalHeader>
            <ModalBody>
                <div className="text-center mb-4">
                    <Icon size={50} className={`text-${color} mb-3`} />
                    <h5 className={`text-${color}`}>{message}</h5>
                    {hint && (
                        <Alert color="info" className="mt-3">
                            <FaInfoCircle className="me-2" />
                            {hint}
                        </Alert>
                    )}
                </div>

                {/* TAMPILKAN DATA JIKA ADA */}
                {hasData && (
                    <>
                        <div className="mb-4">
                            <h6>Ringkasan Import:</h6>
                            <Row className="text-center">
                                <Col md={3}>
                                    <Card body className="bg-light">
                                        <h3 className="text-primary mb-0">{data.totalRows || totalProcessed}</h3>
                                        <small className="text-muted">Total Baris</small>
                                    </Card>
                                </Col>
                                <Col md={3}>
                                    <Card body className={data.success > 0 ? "bg-success text-white" : "bg-light"}>
                                        <h3 className="mb-0">{data.success || 0}</h3>
                                        <small>Berhasil</small>
                                    </Card>
                                </Col>
                                <Col md={3}>
                                    <Card body className={data.failed > 0 ? "bg-danger text-white" : "bg-light"}>
                                        <h3 className="mb-0">{data.failed || 0}</h3>
                                        <small>Gagal</small>
                                    </Card>
                                </Col>
                                <Col md={3}>
                                    <Card body className="bg-light">
                                        <h3 className="mb-0">{data.skipped || 0}</h3>
                                        <small className="text-muted">Diskip</small>
                                    </Card>
                                </Col>
                            </Row>

                            {status !== 'error' && totalProcessed > 0 && (
                                <div className="mt-3">
                                    <div className="d-flex justify-content-between mb-1">
                                        <span>Tingkat Keberhasilan</span>
                                        <span className="fw-bold">{successRate}%</span>
                                    </div>
                                    <Progress 
                                        value={successRate} 
                                        color={successRate > 80 ? 'success' : successRate > 50 ? 'warning' : 'danger'} 
                                    />
                                </div>
                            )}
                        </div>

                        {/* TAMPILKAN DATA DUPLIKAT JIKA ADA */}
                        {hasDuplicates && (
                            <Alert color="warning" className="mb-3">
                                <h6 className="alert-heading">
                                    <FaExclamationTriangle className="me-2" />
                                    Data Duplikat Ditemukan
                                </h6>
                                <p className="mb-2">{duplicates.length} data memiliki nomor surat yang sudah ada di database:</p>
                                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                    <ListGroup>
                                        {duplicates.map((dup, index) => (
                                            <ListGroupItem key={index} className="py-2">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <strong>Baris {dup.row}:</strong> Nomor surat "<strong>{dup.nomorSurat}</strong>" sudah ada
                                                    </div>
                                                    <Badge color="danger" pill>
                                                        Duplikat
                                                    </Badge>
                                                </div>
                                            </ListGroupItem>
                                        ))}
                                    </ListGroup>
                                </div>
                                <small className="mt-2 d-block">
                                    <strong>Solusi:</strong> 
                                    <ul className="mb-0 mt-1">
                                        <li>Periksa nomor surat yang duplikat</li>
                                        <li>Hapus data yang sudah ada terlebih dahulu</li>
                                        <li>Atau gunakan nomor surat yang berbeda</li>
                                    </ul>
                                </small>
                            </Alert>
                        )}

                        {/* TAMPILKAN ERROR DETAIL JIKA ADA */}
                        {hasErrors && (
                            <div className="mb-3">
                                <h6 className="text-danger">
                                    <FaExclamationTriangle className="me-2" />
                                    Detail Error ({data.totalErrors || errors.length}):
                                </h6>
                                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                    <ListGroup>
                                        {errors.map((error, index) => (
                                            <ListGroupItem key={index} color="danger" className="py-2">
                                                <small>{error}</small>
                                            </ListGroupItem>
                                        ))}
                                    </ListGroup>
                                </div>
                                {data.hasMoreErrors && (
                                    <Alert color="warning" className="mt-2 mb-0">
                                        <small>
                                            <FaInfoCircle className="me-2" />
                                            Menampilkan 10 error pertama dari {data.totalErrors} total error.
                                        </small>
                                    </Alert>
                                )}
                            </div>
                        )}

                        {/* TAMPILKAN DATA YANG BERHASIL JIKA ADA */}
                        {data.success > 0 && (
                            <Alert color="success">
                                <FaCheckCircle className="me-2" />
                                <strong>Berhasil mengimport {data.success} data.</strong> Data telah ditambahkan ke database.
                            </Alert>
                        )}
                    </>
                )}

                {/* JIKA TIDAK ADA DATA SAMA SEKALI */}
                {!hasData && (
                    <Alert color="danger">
                        <FaTimes className="me-2" />
                        <strong>Import gagal:</strong> {message}
                        {hint && (
                            <div className="mt-2">
                                <small>{hint}</small>
                            </div>
                        )}
                    </Alert>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color={color} onClick={() => setShowImportModal(false)}>
                    Tutup
                </Button>
                {hasData && data.success > 0 && (
                    <Button color="primary" onClick={() => {
                        setShowImportModal(false);
                        fetchData();
                    }}>
                        <FaEye className="me-2" />
                        Lihat Data Terbaru
                    </Button>
                )}
                {hasDuplicates && (
                    <Button color="warning" onClick={() => {
                        setShowImportModal(false);
                        // Optional: Navigate ke halaman data untuk melihat duplikat
                        setFilters(prev => ({ ...prev, searchNoSurat: duplicates[0].nomorSurat }));
                    }}>
                        <FaSearch className="me-2" />
                        Kembali Ke halaman Data
                    </Button>
                )}
            </ModalFooter>
        </Modal>
    );
};
  const VerifikasiModal = () => {
    const getStatusInfo = () => {
      switch (verifikasiData.status) {
        case "Disetujui":
          return { color: "success", text: "Disetujui", icon: <FaUserCheck className="me-2" /> };
        case "Diproses":
          return { color: "warning", text: "Diproses", icon: <FaHourglassHalf className="me-2" /> };
        case "Ditolak":
          return { color: "danger", text: "Ditolak", icon: <FaUserTimes className="me-2" /> };
        default:
          return { color: "secondary", text: "", icon: null };
      }
    };

    const statusInfo = getStatusInfo();

    return (
      <Modal isOpen={isVerifikasiModalOpen} toggle={() => !verifikasiLoading && setIsVerifikasiModalOpen(false)}>
        <ModalHeader toggle={() => !verifikasiLoading && setIsVerifikasiModalOpen(false)}>
          Konfirmasi Verifikasi
        </ModalHeader>
        <ModalBody>
          <div className="text-center">
            <div className="mb-3">
              <Badge color={statusInfo.color} className="p-2" style={{ fontSize: '1.1rem' }}>
                {statusInfo.icon}
                {statusInfo.text}
              </Badge>
            </div>
            <p>Apakah Anda yakin ingin mengubah status usulan ini menjadi <strong>{statusInfo.text}</strong>?</p>
            <div className="text-start bg-light p-3 rounded">
              <p><strong>Nama Pemohon:</strong> {verifikasiData.item?.namaPemohonLembagaPengusul}</p>
              <p><strong>Nama Kepala Keluarga:</strong> {verifikasiData.item?.namaKepalaKeluarga}</p>
              <p><strong>Perihal:</strong> {verifikasiData.item?.perihal}</p>
              <p><strong>Status Saat Ini:</strong>
                <Badge color={
                  verifikasiData.item?.status === 'Disetujui' ? 'success' :
                    verifikasiData.item?.status === 'Ditolak' ? 'danger' : 'warning'
                } className="ms-2">
                  {verifikasiData.item?.status}
                </Badge>
              </p>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsVerifikasiModalOpen(false)} disabled={verifikasiLoading}>
            Batal
          </Button>
          <Button color={statusInfo.color} onClick={confirmVerifikasi} disabled={verifikasiLoading}>
            {verifikasiLoading ? <Spinner size="sm" /> : statusInfo.icon}
            {verifikasiLoading ? 'Memproses...' : 'Ya, Ubah Status'}
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Button
          key={i}
          color={i === currentPage ? "primary" : "outline-primary"}
          size="sm"
          onClick={() => handlePageChange(i)}
          className="mx-1"
        >
          {i}
        </Button>
      );
    }

    return (
      <div className="d-flex justify-content-center align-items-center mt-3">
        <Button
          color="outline-primary"
          size="sm"
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
          className="mx-1"
        >
          <FaAngleDoubleLeft />
        </Button>
        <Button
          color="outline-primary"
          size="sm"
          onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="mx-1"
        >
          <FaAngleLeft />
        </Button>
        {pages}
        <Button
          color="outline-primary"
          size="sm"
          onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="mx-1"
        >
          <FaAngleRight />
        </Button>
        <Button
          color="outline-primary"
          size="sm"
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
          className="mx-1"
        >
          <FaAngleDoubleRight />
        </Button>
      </div>
    );
  };

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Sync scroll between top and bottom scrollbars
  const handleTopScroll = (e) => {
    if (tableScrollRef.current) {
      tableScrollRef.current.scrollLeft = e.target.scrollLeft;
    }
  };

  const handleTableScroll = (e) => {
    if (topScrollRef.current) {
      topScrollRef.current.scrollLeft = e.target.scrollLeft;
    }
  };

  // Update top scrollbar width when table content changes
  useEffect(() => {
    if (topScrollRef.current && tableScrollRef.current) {
      const tableContent = tableScrollRef.current.querySelector('table');
      if (tableContent) {
        const scrollContent = topScrollRef.current.querySelector('.scroll-content');
        if (scrollContent) {
          scrollContent.style.width = `${tableContent.offsetWidth}px`;
        }
      }
    }
  }, [data, loading]);

  const contentStyle = isMobile
    ? {}
    : { marginLeft: "250px" };

  return (
    <div className="data-content-wrapper">
      <div className="main-content" style={contentStyle}>
        <Container fluid className="data-recap-page p-2 p-md-4">
          <CardHeader>
            <h4 className="mb-0">Daftar Register Usulan</h4>
          </CardHeader>
          <CardBody>

            <Filters
              filters={filters}
              user={user}
              onChange={handleFilterChange}
              kecamatanList={Object.keys(kecamatanOptions)}
              desaOptions={filterDesaOptions}
              userOptions={userOptions}
            />
            <Row className="mb-3 g-2">
              <Col xs={12} md={6} className="d-flex align-items-end">
                <div>
                  {user && user.role === "admin" && (
                    <div className="p-3 bg-light rounded border mb-3">
                      <h5 className="mb-3">Export Data PerKecamatan (Admin)</h5>
                      <Row>
                        <Col md={6}>
                          <div className="form-group mb-3">
                            <label htmlFor="exportKecamatan" className="form-label fw-bold">
                              Pilih Kecamatan:
                            </label>
                            <select
                              id="exportKecamatan"
                              className="form-select"
                              value={selectedKecamatan}
                              onChange={(e) => setSelectedKecamatan(e.target.value)}
                            >
                              <option value="">Semua Kecamatan</option>
                              {Object.keys(kecamatanOptions).map(kec => (
                                <option key={kec} value={kec}>{kec}</option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col md={6} className="d-flex align-items-end">
                          <Button
                            color="success"
                            onClick={handleAdminExport}
                            style={{
                              borderRadius: "6px",
                              border: "none",
                              width: "100%",
                            }}
                          >
                            <FaDownload className="me-2" />
                            Export by Kecamatan
                          </Button>
                        </Col>
                      </Row>
                      <small className="text-muted">
                        {selectedKecamatan
                          ? `Akan mengexport data untuk kecamatan: ${selectedKecamatan}`
                          : 'Akan mengexport semua data kecamatan'
                        }
                      </small>
                    </div>
                  )}
                </div>
              </Col>
              <Col xs={12} md={6} className="d-flex align-items-end justify-content-md-end">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  {!isReadOnly && <>
                    <input
                      type="file"
                      id="fileMasuk"
                      accept=".xlsx,.xls"
                      style={{ display: 'none' }}
                      onChange={onPickImportFile}
                    />
                    <Button
                      color="info"
                      onClick={() => document.getElementById("fileMasuk").click()}
                      disabled={importLoading}
                    >
                      <FaDownload className="me-2" />
                      Pilih Excel
                    </Button>
                  </>}
                  {!isReadOnly && importFile && (
    <Badge color="secondary" pill className="py-2 px-3 d-flex align-items-center">
        <span className="text-truncate" style={{ maxWidth: '200px' }}>
            {importFile.name}
        </span>
        <FaTimes
            className="ms-2 flex-shrink-0"
            style={{ cursor: 'pointer' }}
            onClick={() => {
                setImportFile(null);
                document.getElementById("fileMasuk").value = '';
            }}
        />
    </Badge>
)}
                  {!isReadOnly && <Button
                    color="primary"
                    disabled={!importFile || importLoading}
                    onClick={onSubmitImport}
                  >
                    {importLoading ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Mengupload...
                      </>
                    ) : (
                      <>
                        <FaDownload className="me-2" />
                        Upload Excel
                      </>
                    )}
                  </Button>}

                  {!isReadOnly && <Button
                    color="success"
                    onClick={() => navigate("/registerdata")}
                  >
                    <FaPlus className="me-2" />Tambah Data
                  </Button>}
                </div>
              </Col>
            </Row>

            {error && <Alert color="danger" toggle={() => setError("")}>{error}</Alert>}
            {success && <Alert color="success" toggle={() => setSuccess("")}>{success}</Alert>}

            {/* Top Scrollbar */}
            <div 
              ref={topScrollRef}
              onScroll={handleTopScroll}
              style={{ 
                overflowX: 'auto', 
                overflowY: 'hidden',
                marginBottom: '10px',
                border: '1px solid #dee2e6',
                borderRadius: '4px',
                backgroundColor: '#f8f9fa'
              }}
            >
              <div className="scroll-content" style={{ height: '20px' }}></div>
            </div>

            <div 
              ref={tableScrollRef}
              onScroll={handleTableScroll}
              className="table-responsive"
            >
              <Table striped hover>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Tanggal</th>
                    <th>Nomor Surat</th>
                    <th>Tanggal Surat</th>
                    <th>Nama Pemohon</th>
                    <th>Nama Kepala Keluarga</th>
                    <th>NO KK</th>
                    <th>NIK</th>
                    <th>Alamat</th>
                    <th>Kecamatan</th>
                    <th>Desa/Kelurahan</th>
                    <th>Perihal</th>
                    <th>Status</th>
                    <th>Aksi</th>
                    {user && (user.role === "admin" || user.role === "inputdata") && <th>Validasi</th>}
                  </tr>
                </thead>
                <tbody>
                  {!loading && data && data.length > 0 ? (
                    data.map((item, idx) => (
                      <tr key={item.id}>
                        <td>{(currentPage - 1) * limit + idx + 1}</td>
                        <td>{item.tanggalDiterima ? moment(item.tanggalDiterima).format('YYYY-MM-DD') : '-'}</td>
                        <td>{item.nomorSurat}</td>
                        <td>{item.tanggalSurat ? moment(item.tanggalSurat).format('YYYY-MM-DD') : '-'}</td>
                        <td>{item.namaPemohonLembagaPengusul}</td>
                        <td>{item.namaKepalaKeluarga}</td>
                        <td>{item.nomorKK}</td>
                        <td>{item.nik}</td>
                        <td>{item.alamatPemohon}</td>
                        <td>{item.kecamatan}</td>
                        <td>{item.desaKelurahan}</td>
                        <td>{item.perihal}</td>
                        <td>
                          <Badge color={item.status === 'Disetujui' ? 'success' : item.status === 'Ditolak' ? 'danger' : 'warning'}>{item.status}</Badge>
                        </td>
                        <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                          <div className="d-flex justify-content-center align-items-center" style={{ gap: 4 }}>
                            <Button color="info" title="Lihat Detail"
                              className="d-inline-flex align-items-center justify-content-center text-white"
                              style={{ width: 32, height: 32, padding: 0, border: 'none', lineHeight: 0 }}
                              onClick={() => { setSelectedItem(item); setIsViewModalOpen(true); }}>
                              <FaEye size={14} />
                            </Button>
                            {!isReadOnly && (
                              <Button color="warning" title="Edit"
                                className="d-inline-flex align-items-center justify-content-center text-white"
                                style={{ width: 32, height: 32, padding: 0, border: 'none', lineHeight: 0 }}
                                onClick={() => { setSelectedItem(item); setIsEditModalOpen(true); }}>
                                <FaEdit size={14} />
                              </Button>
                            )}
                            <Button
                              color="success"
                              title="Unduh Laporan (Data + Lampiran)"
                              className="d-inline-flex align-items-center justify-content-center text-white"
                              style={{ width: 32, height: 32, padding: 0, border: 'none', lineHeight: 0 }}
                              onClick={() => handleDownloadFullPDF(item)}
                              disabled={loading}
                            >
                              <FaFilePdf size={14} />
                            </Button>
                            {item.file && (
                              <Button
                                color="primary"
                                title="Preview Lampiran PDF"
                                className="d-inline-flex align-items-center justify-content-center text-white"
                                style={{ width: 32, height: 32, padding: 0, border: 'none', lineHeight: 0 }}
                                onClick={() => openInAppFilePreview({
                                  url: toProtectedFileUrl(item.file),
                                  title: `Lampiran — ${item.namaKepalaKeluarga || item.id}`
                                })}
                              >
                                <FaFileAlt size={14} />
                              </Button>
                            )}
                            <Button
                              color="secondary"
                              title={item.file ? "Unduh Lampiran PDF Saja" : "Tidak ada lampiran"}
                              className="d-inline-flex align-items-center justify-content-center text-white"
                              style={{ width: 32, height: 32, padding: 0, border: 'none', lineHeight: 0, opacity: item.file ? 1 : 0.45 }}
                              onClick={() => handleDownload(item)}
                              disabled={loading || !item.file}
                            >
                              <FaFileDownload size={14} />
                            </Button>
                            {!isReadOnly && (
                              <Button color="danger" title="Hapus"
                                className="d-inline-flex align-items-center justify-content-center text-white"
                                style={{ width: 32, height: 32, padding: 0, border: 'none', lineHeight: 0 }}
                                onClick={() => { setSelectedItem(item); setIsDeleteModalOpen(true); }}>
                                <FaTrash size={14} />
                              </Button>
                            )}
                          </div>
                        </td>
                        {user && (user.role === "admin" || user.role === "inputdata") &&
                          <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                            <div className="d-flex justify-content-center align-items-center" style={{ gap: 4 }}>
                              <Button
                                color="success"
                                title="Setujui"
                                className="d-inline-flex align-items-center justify-content-center text-white"
                                style={{ width: 32, height: 32, padding: 0, border: 'none', lineHeight: 0 }}
                                onClick={() => handleVerifikasi(item, "Disetujui")}
                              >
                                <FaUserCheck size={14} />
                              </Button>
                              <Button
                                color="warning"
                                title="Proses"
                                className="d-inline-flex align-items-center justify-content-center text-white"
                                style={{ width: 32, height: 32, padding: 0, border: 'none', lineHeight: 0 }}
                                onClick={() => handleVerifikasi(item, "Diproses")}
                              >
                                <FaHourglassHalf size={14} />
                              </Button>
                              <Button
                                color="danger"
                                title="Tolak"
                                className="d-inline-flex align-items-center justify-content-center text-white"
                                style={{ width: 32, height: 32, padding: 0, border: 'none', lineHeight: 0 }}
                                onClick={() => handleVerifikasi(item, "Ditolak")}
                              >
                                <FaUserTimes size={14} />
                              </Button>
                            </div>
                          </td>
                        }
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center">
                        {loading ? <Spinner size="sm" /> : 'Tidak ada data'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            <Row className="mt-3">
              <Col md={2}>
                <FormGroup>
                  <Label for="limit">Items per page</Label>
                  <Input
                    type="select"
                    name="limit"
                    id="limit"
                    value={limit}
                    onChange={handleLimitChange}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <p className="text-muted">
                  Menampilkan {totalItems === 0 ? 0 : ((currentPage - 1) * limit) + 1} sampai {Math.min(currentPage * limit, totalItems)} dari {totalItems} data
                </p>
              </Col>
              <Col md={6}>
                {renderPagination()}
              </Col>
            </Row>
          </CardBody>
        </Container>
      </div>

      {/* MODALS */}
      <VerifikasiModal />
      <ImportResultModal />
      <CreateModal
        isOpen={isCreateModalOpen}
        toggle={() => setIsCreateModalOpen(false)}
        onSubmit={handleCreate}
        desaOptions={desaOptions}
        errors={{}}
      />
      <EditModal
        isOpen={isEditModalOpen}
        toggle={() => setIsEditModalOpen(false)}
        item={selectedItem}
        onSubmit={handleUpdate}
        desaOptions={desaOptions}
      />
      <ViewModal
        isOpen={isViewModalOpen}
        toggle={() => setIsViewModalOpen(false)}
        item={selectedItem}
      />
      <DeleteModal
        isOpen={isDeleteModalOpen}
        toggle={() => setIsDeleteModalOpen(false)}
        item={selectedItem}
        onConfirm={handleDelete}
      />
    </div>
  );
}

export default RegisterUsulan
